/**
 * Paddle (Merchant of Record, seller HustleMania) web coin-pack checkout — SANDBOX ONLY for now.
 * WEB ONLY: iOS / Android builds must never show or link to Paddle (App Store 3.1.1, Play billing); the web client
 * gates on platform before loading Paddle.js. Coins are cosmetic-only and credited server-side by the
 * handegg-server Paddle webhook (POST /paddle/webhook) on `transaction.completed`, once per transaction id.
 */
/**
 * THE switch for buying coins on the web. Off: no coin pack is purchasable in a browser and Paddle checkout never
 * opens (the store shows `WEB_COINS_NOTE` instead, no prices, no buy buttons). The Paddle code stays in place behind
 * it. Coin SPENDING (heads / ball skins bought with coins) is unaffected. Native apps buy coins via their own stores.
 */
export const WEB_COIN_PURCHASES_ENABLED: boolean = false;

/** Shown on the web in place of the coin packs while web purchases are off. */
export const WEB_COINS_NOTE = 'Coins are available in the iOS and Android app.';

export const PADDLE_ENVIRONMENT = 'sandbox' as const;

/** Paddle.js client-side token (public by design; sandbox). */
export const PADDLE_CLIENT_TOKEN = 'test_6aea5ecf0ddc59491b605791a13';

/** Sandbox product "Hand Egg Coins". */
export const PADDLE_PRODUCT_ID = 'pro_01m503njkt747rzhh6d8bbash6';

/** One Paddle price per `COIN_PACKS` id (USD, same as the store tiers). */
export const PADDLE_PRICE_IDS: Readonly<Record<string, string>> = Object.freeze({
  pocket: 'pri_01m503njvehkdvwhm3xe5vkxjy',
  bag: 'pri_01m503nk246z86x85ykya14kvz',
  chest: 'pri_01m503nk8wyv98hm92anefqy1g',
  vault: 'pri_01m503nkfnv3x1ya3kmjpm08ea',
  hall_of_fame: 'pri_01m503nkpwb5sd9fz8s5h5zmdh',
});

/** Reverse map: Paddle price id → coin pack id (undefined for an unknown price). */
export const paddlePackForPrice = (priceId: string): string | undefined =>
  Object.keys(PADDLE_PRICE_IDS).find((k) => PADDLE_PRICE_IDS[k] === priceId);
